import React from 'react';
var Ball = function () { return (React.createElement("div", { className: 'timeline__ball' })); };
export default Ball;
